import { Component, OnInit } from '@angular/core';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';

@Component({
  selector: 'tt-paperless-production',
  templateUrl: './paperless-production.component.html',
  styleUrls: ['./paperless-production.component.css']
})
export class PaperlessProductionComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListFactories: FactoryItem[] = [];

    public selectListEquipments: Item[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2054))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadFactories() {
        if (!this.setting) return;

        this.selectListFactories = await this.datatask.Post(2024, { businessco_no: this.setting.businessco_no });
    }

    private async loadEquipments() {
        if (!this.setting) return;

        this.selectListEquipments = await this.datatask.Post(2039, { factory_id: this.setting.factory_id });
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadFactories();
                break;
            case 'factory_id':
                Promise.all([
                    this.loadEquipments()
                ]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'equipment_id':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        this.loadGrid();
    }

    private async init() {
        await this.loadSetting();

        return Promise.all([
            this.loadCompanies(),
            this.loadFactories(),
            this.loadEquipments()
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    factory_id: string;
    equipment_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
    p2_datatask_keyno: number;
    view_id: string;
}

interface FactoryItem {
    factory_id: string;
    factory_name: string;
    orderby: number;
}
